module.exports = __webpack_public_path__ + "27dfd0e04556e2c068b1405c99f50a2f.MP3";